import URLHandler from 'assets/URLHandler.js'

export const DEFAULT_TAB = 'overview'

export const TAB_TRANSLATION_MAPPING = {
    faculties: { en: 'faculties', nl: 'faculteiten', fr: 'departements' },
    featured_campuses: { en: 'campuses', nl: 'campussen', fr: 'campus' },
    overview: { en: '', nl: '', fr: '' },
    jobs: { en: 'jobs', nl: 'jobs', fr: 'jobs' },
    news: { en: 'news', nl: 'news', fr: 'news' }
}

const TranslateTab = (tabValue) => {
    const translatedTab = TAB_TRANSLATION_MAPPING[tabValue] && TAB_TRANSLATION_MAPPING[tabValue][URLHandler.GetLocaleFromUrl()]
    return translatedTab
}

const TabToValue = (translatedTabString) => {
    for (const [tabKey, translations] of Object.entries(TAB_TRANSLATION_MAPPING)) {
        if (Object.values(translations).includes(translatedTabString)) {
            return tabKey
        }
    }
    return translatedTabString
}

export const getTabFromUrl = (tabs) => {
    const currentPath = window.location.pathname
    const lastSegment = currentPath.split('/').pop()
    const translatedLastSegment = TabToValue(lastSegment)
    if (tabs.some((t) => t.value === translatedLastSegment)) return translatedLastSegment
}

export const GetURL = (tabString, tabsParams) => {
    const tab = tabString
    const translatedTab = TranslateTab(tabString)
    const tabs = tabsParams.map((t) => t.value)
    const currentUrl = new URL(window.location.href)
    const currentPath = currentUrl.pathname
    const queryParams = new URLSearchParams(currentUrl.search)

    let newPath
    const lastSegment = TabToValue(currentPath.split('/').pop())
    if (tab === DEFAULT_TAB) {
        newPath = tabs.includes(lastSegment) ? currentPath.split('/').slice(0, -1).join('/') : currentPath
    } else if (tabs.includes(lastSegment)) {
        newPath = `${currentPath.split('/').slice(0, -1).join('/')}/${translatedTab}`
    } else {
        newPath = `${currentPath}/${translatedTab}`
    }
    newPath = newPath.replace(/\/\//g, '/')
    if (queryParams.toString()) {
        newPath = `${newPath}?${queryParams.toString()}`
    }

    return newPath
}

export const updateURL = (tabString, tabsParams) => {
    history.replaceState(null, '', GetURL(tabString, tabsParams))
}
